// CSV serializer for Excel-Hebrew (UTF-8 + BOM). No new dep.
// Usage:
//   const blob = toCsv(rows, [{ key: 'full_name', header: 'שם' }, ...]);
//   downloadBlob(blob, `leads_${dateStamp()}.csv`);

export interface CsvColumn<T> {
  key: keyof T;
  header: string;
}

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return '""';
  let s: string;
  if (typeof value === 'string') s = value;
  else if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    s = String(value);
  } else if (value instanceof Date) s = value.toISOString();
  else s = JSON.stringify(value);
  return `"${s.replace(/"/g, '""')}"`;
}

export function toCsv<T extends object>(rows: T[], cols: CsvColumn<T>[]): Blob {
  const headerLine = cols.map((c) => escapeCell(c.header)).join(',');
  const bodyLines = rows.map((row) => cols.map((c) => escapeCell(row[c.key])).join(','));
  const csv = [headerLine, ...bodyLines].join('\n');
  // BOM (U+FEFF) forces Excel to read as UTF-8 (Hebrew safe).
  return new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' });
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function dateStamp(d: Date = new Date()): string {
  const yyyy = String(d.getFullYear());
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
